import { Avatar, Box, Typography, useTheme } from '@mui/material';
import React from 'react';

const commenters = [
  {
    name: 'Tordy György',
    comment:
      '"Az emberiség fejlődését mindig a tudás megosztása vitte előre. Amennyiben tanyán élsz vagy szeretnél akkor a Tanya Egyetem tudásbázisa segíthet az életformád könnyebbé tételében."',
    image: './img/rolunkMondtak/TordyGyorgy.jpg',
  },
  {
    name: 'Mátrai Gábor',
    comment:
      '“Példaképek számomra! Szeretettel bánnak minden érdeklődővel, ha ugyanazt a kérdést is hallják már 5000-szer, akkor is ugyanolyan szeretettel válaszolnak mindenkinek. Magot ültetnek és táplálnak az emberben. A remény magját…. hogy én is ugyanúgy meg tudom teremteni az élelmiszeremet, ahogyan Ők. Leghitelesebb házaspár Magyarországon! Köszönöm Kriszti & Misi!”',
    image: './img/rolunkMondtak/MatraiGabor.jfif',
  },
  {
    name: 'Jankovits Béla',
    comment:
      '"Mindegy, hogy valaki kezdő vagy rutinosabb az önellátásban, szerintem a Tanyaegyetem mindig mutat valami újat, érdekeset és hasznosat mindenkinek. Meghozza a kedvet a tanyasi élethez!"',
    image: './img/rolunkMondtak/JankovicsBela.jfif',
  },
  {
    name: 'Ferhécz Anett',
    comment:
      '“14 év tanyasi élet, annak MINDEN szakmai tapasztalatával, gyakorlati szinten videókban megosztva. Egyedüliek az országban. Felköltöztem miattuk 6 hónapra Ceglédre. Minden nap Krisztivel és Misivel, a gyerekekkel voltam. Nem kérdés, kitől akarok tanulni! Gyere Te is a Tanyaegyetemre, ahol minden tudás egy helyen Érted és Értem!”',
    image: './img/rolunkMondtak/FerheczAnett.jfif',
  },
];

const Comments = () => {
  const theme = useTheme();
  return (
    <Box display='flex' justifyContent='center' flexWrap='wrap' gap={2} p={4}>
      {commenters.map((presenter, index) => (
        <Box
          key={index}
          display='flex'
          flexDirection='column' // 🔹 Elemek egymás alá kerülnek
          alignItems='center' // 🔹 Középre igazítja az Avatar-t és a szöveget is
          textAlign='center' // 🔹 Elemek egymás alá kerülnek
        >
          <Avatar
            src={presenter.image}
            alt={presenter.name}
            sx={{
              width: 100,
              height: 100,
              border: `3px solid ${theme.palette.primary.main}`,
            }}
          />
          <Typography variant='subtitle1' mt={1}>
            {presenter.name}
          </Typography>
          <Typography variant='blockquote' mt={1} maxWidth={270} mx='auto'>
            {presenter.comment}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Comments;
